const hamburgerData = [
  {
    url: '/about-us',
    name: {
      en: 'about us',
      ka: 'ჩვენ შესახებ'
    },
    children: [
      {
        url: '/guest-service',
        name: {
          en: 'GUEST SERVICES',
          ka: 'მომსახურება'
        }
      },
      {
        url: '/mall-map',
        name: {
          en: 'mall map',
          ka: 'მოლის რუქა'
        }
      },
      // {
      //   url: '/mall-taxi',
      //   name: {
      //     en: 'tbilisi mall taxi',
      //     ka: 'თბილისი მოლის ტაქსი'
      //   }
      // },
      {
        url: '/marketing',
        name: {
          en: 'marketing',
          ka: 'მარკეტინგი'
        }
      },
      {
        url: '/gift-card',
        name: {
          en: 'Gift Card',
          ka: 'სასაჩუქრე ბარათი'
        }
      },
      {
        url: '/leasing',
        name: {
          en: 'leasing',
          ka: 'ლიზინგი'
        }
      },
      {
        url: '/magazine',
        name: {
          en: 'magazine',
          ka: 'ჟურნალი'
        }
      }
    ]
  },
  {
    url: '/whats-new',
    name: {
      en: 'what\'s new',
      ka: 'სიახლეები'
    },
    children: [
      {
        url: '/promotions',
        name: {
          ka: 'შეთავაზებები',
          en: 'promotions'
        }
      },
      {
        url: '/new-collections',
        name: {
          ka: 'ახალი კოლექციები',
          en: 'new collections'
        }
      },
      {
        url: '/events',
        name: {
          ka: 'ღონისძიებები',
          en: 'events'
        }
      },
      {
        url: '/news',
        name: {
          ka: 'სიახლეები',
          en: 'news'
        }
      }
    ]
  },
  {
    url: '/stores',
    name: {
      en: 'stores',
      ka: 'მაღაზიები'
    },
    children: [
      {
        url: '/fashion',
        name: {
          ka: 'მოდა',
          en: 'fashion'
        }
      },
      {
        url: '/books-and-stationary',
        name: {
          ka: 'წიგნები',
          en: 'BOOKS AND STATIONARY'
        }
      },
      {
        url: '/shoes',
        name: {
          ka: 'ფექსაცმელები',
          en: 'SHOES'
        }
      },
      {
        url: '/tech',
        name: {
          ka: 'ტექნიკა',
          en: 'Technic'
        }
      },
      {
        url: '/kids',
        name: {
          ka: 'ბავშვები',
          en: 'kids'
        }
      },
      {
        url: '/plants',
        name: {
          ka: 'მცენარეები',
          en: 'plants'
        }
      },
      {
        url: '/accessories',
        name: {
          ka: 'სამკაულები',
          en: 'ACCESSORIES'
        }
      },
      {
        url: '/health-beauty',
        name: {
          ka: 'სილამაზე და ჯანრმრთელობა',
          en: 'health and beauty'
        }
      },
      {
        url: '/household',
        name: {
          ka: 'სახლისთვის',
          en: 'household'
        }
      },
      {
        url: '/news',
        name: {
          ka: 'სიახლეები',
          en: 'news'
        }
      },
      {
        url: '/hypermarkets',
        name: {
          ka: 'ჰიპერმარკეტები',
          en: 'hypermarkets'
        }
      },
      {
        url: '/souvenirs',
        name: {
          ka: 'სუვენირები',
          en: 'souvenirs'
        }
      },
      {
        url: '/specialty-stores',
        name: {
          ka: 'სპეციფიური მაღაზიები',
          en: 'SPECIALTY STORES'
        }
      }
    ]
  },
  {
    url: '/entertainment',
    name: {
      en: 'entertainment',
      ka: 'გართობა'
    },
    children: true
  },
  {
    url: '/services',
    name: {
      en: 'services',
      ka: 'სერვისები'
    },
    children: true
  }
]

export default hamburgerData
